/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Providers.Api
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorApiOutContract,
  GetVisitsV2Params,
  GetVisitsVisitIdV2Params,
  GetVisitsWaitingroomV2Params,
  PhoneCallAccessTokenDoctorApiOutContract,
  VisitCollectionItemDoctorApiOutContractPaginationItemCollectionApiOutContract,
  VisitV2DoctorApiOutContract,
  VisitVideoDoctorApiOutContract,
  WaitingRoomV2VisitListItemDoctorApiOutContract
} from '../pwrdbyQuickMDProvidersApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Retrieves information related to a specific visit.
 */
export const getVisitsVisitIdV2 = (
    visitId: string,
    params?: GetVisitsVisitIdV2Params,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<VisitV2DoctorApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v2/visits/${encodeURIComponent(String(visitId))}`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetVisitsVisitIdV2InfiniteQueryKey = (visitId?: string,
    params?: GetVisitsVisitIdV2Params,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v2/visits/${visitId}`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetVisitsVisitIdV2QueryKey = (visitId?: string,
    params?: GetVisitsVisitIdV2Params,) => {
    return [
    `https://providers-api.api.quick.md/api/v2/visits/${visitId}`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetVisitsVisitIdV2InfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdV2>>>, TError = void | ErrorApiOutContract>(visitId: string,
    params?: GetVisitsVisitIdV2Params, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdV2InfiniteQueryKey(visitId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdV2>>> = ({ signal }) => getVisitsVisitIdV2(visitId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(visitId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdV2InfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdV2>>>
export type GetVisitsVisitIdV2InfiniteQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdV2Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdV2>>>, TError = void | ErrorApiOutContract>(
 visitId: string,
    params: undefined |  GetVisitsVisitIdV2Params, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdV2>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdV2Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdV2>>>, TError = void | ErrorApiOutContract>(
 visitId: string,
    params?: GetVisitsVisitIdV2Params, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdV2>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdV2Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdV2>>>, TError = void | ErrorApiOutContract>(
 visitId: string,
    params?: GetVisitsVisitIdV2Params, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves information related to a specific visit.
 */

export function useGetVisitsVisitIdV2Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdV2>>>, TError = void | ErrorApiOutContract>(
 visitId: string,
    params?: GetVisitsVisitIdV2Params, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdV2InfiniteQueryOptions(visitId,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves information related to a specific visit.
 */
export const prefetchGetVisitsVisitIdV2InfiniteQuery = async <TData = Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, visitId: string,
    params?: GetVisitsVisitIdV2Params, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsVisitIdV2InfiniteQueryOptions(visitId,params,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsVisitIdV2QueryOptions = <TData = Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError = void | ErrorApiOutContract>(visitId: string,
    params?: GetVisitsVisitIdV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdV2QueryKey(visitId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdV2>>> = ({ signal }) => getVisitsVisitIdV2(visitId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(visitId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdV2QueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdV2>>>
export type GetVisitsVisitIdV2QueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdV2<TData = Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError = void | ErrorApiOutContract>(
 visitId: string,
    params: undefined |  GetVisitsVisitIdV2Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdV2>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdV2<TData = Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError = void | ErrorApiOutContract>(
 visitId: string,
    params?: GetVisitsVisitIdV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdV2>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdV2<TData = Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError = void | ErrorApiOutContract>(
 visitId: string,
    params?: GetVisitsVisitIdV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves information related to a specific visit.
 */

export function useGetVisitsVisitIdV2<TData = Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError = void | ErrorApiOutContract>(
 visitId: string,
    params?: GetVisitsVisitIdV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdV2QueryOptions(visitId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves information related to a specific visit.
 */
export const prefetchGetVisitsVisitIdV2Query = async <TData = Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, visitId: string,
    params?: GetVisitsVisitIdV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsVisitIdV2QueryOptions(visitId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsVisitIdV2SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError = void | ErrorApiOutContract>(visitId: string,
    params?: GetVisitsVisitIdV2Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdV2QueryKey(visitId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdV2>>> = ({ signal }) => getVisitsVisitIdV2(visitId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdV2SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdV2>>>
export type GetVisitsVisitIdV2SuspenseQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdV2Suspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError = void | ErrorApiOutContract>(
 visitId: string,
    params: undefined |  GetVisitsVisitIdV2Params, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdV2Suspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError = void | ErrorApiOutContract>(
 visitId: string,
    params?: GetVisitsVisitIdV2Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdV2Suspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError = void | ErrorApiOutContract>(
 visitId: string,
    params?: GetVisitsVisitIdV2Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves information related to a specific visit.
 */

export function useGetVisitsVisitIdV2Suspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError = void | ErrorApiOutContract>(
 visitId: string,
    params?: GetVisitsVisitIdV2Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdV2SuspenseQueryOptions(visitId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetVisitsVisitIdV2SuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdV2>>>, TError = void | ErrorApiOutContract>(visitId: string,
    params?: GetVisitsVisitIdV2Params, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdV2InfiniteQueryKey(visitId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdV2>>> = ({ signal }) => getVisitsVisitIdV2(visitId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdV2SuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdV2>>>
export type GetVisitsVisitIdV2SuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdV2SuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdV2>>>, TError = void | ErrorApiOutContract>(
 visitId: string,
    params: undefined |  GetVisitsVisitIdV2Params, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdV2SuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdV2>>>, TError = void | ErrorApiOutContract>(
 visitId: string,
    params?: GetVisitsVisitIdV2Params, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdV2SuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdV2>>>, TError = void | ErrorApiOutContract>(
 visitId: string,
    params?: GetVisitsVisitIdV2Params, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves information related to a specific visit.
 */

export function useGetVisitsVisitIdV2SuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdV2>>>, TError = void | ErrorApiOutContract>(
 visitId: string,
    params?: GetVisitsVisitIdV2Params, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdV2SuspenseInfiniteQueryOptions(visitId,params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Retrieves a collection of visits based on the specified filter criteria.
 */
export const getVisitsV2 = (
    params?: GetVisitsV2Params,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<VisitCollectionItemDoctorApiOutContractPaginationItemCollectionApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v2/visits`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetVisitsV2InfiniteQueryKey = (params?: GetVisitsV2Params,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v2/visits`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetVisitsV2QueryKey = (params?: GetVisitsV2Params,) => {
    return [
    `https://providers-api.api.quick.md/api/v2/visits`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetVisitsV2InfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisitsV2>>>, TError = void | ErrorApiOutContract>(params?: GetVisitsV2Params, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsV2InfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsV2>>> = ({ signal }) => getVisitsV2(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsV2InfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsV2>>>
export type GetVisitsV2InfiniteQueryError = void | ErrorApiOutContract


export function useGetVisitsV2Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsV2>>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetVisitsV2Params, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsV2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsV2>>,
          TError,
          Awaited<ReturnType<typeof getVisitsV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsV2Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsV2>>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsV2Params, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsV2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsV2>>,
          TError,
          Awaited<ReturnType<typeof getVisitsV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsV2Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsV2>>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsV2Params, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a collection of visits based on the specified filter criteria.
 */

export function useGetVisitsV2Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsV2>>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsV2Params, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsV2InfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves a collection of visits based on the specified filter criteria.
 */
export const prefetchGetVisitsV2InfiniteQuery = async <TData = Awaited<ReturnType<typeof getVisitsV2>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, params?: GetVisitsV2Params, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsV2InfiniteQueryOptions(params,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsV2QueryOptions = <TData = Awaited<ReturnType<typeof getVisitsV2>>, TError = void | ErrorApiOutContract>(params?: GetVisitsV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsV2QueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsV2>>> = ({ signal }) => getVisitsV2(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVisitsV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsV2QueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsV2>>>
export type GetVisitsV2QueryError = void | ErrorApiOutContract


export function useGetVisitsV2<TData = Awaited<ReturnType<typeof getVisitsV2>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetVisitsV2Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsV2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsV2>>,
          TError,
          Awaited<ReturnType<typeof getVisitsV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsV2<TData = Awaited<ReturnType<typeof getVisitsV2>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsV2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsV2>>,
          TError,
          Awaited<ReturnType<typeof getVisitsV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsV2<TData = Awaited<ReturnType<typeof getVisitsV2>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a collection of visits based on the specified filter criteria.
 */

export function useGetVisitsV2<TData = Awaited<ReturnType<typeof getVisitsV2>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsV2QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves a collection of visits based on the specified filter criteria.
 */
export const prefetchGetVisitsV2Query = async <TData = Awaited<ReturnType<typeof getVisitsV2>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, params?: GetVisitsV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsV2QueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsV2SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getVisitsV2>>, TError = void | ErrorApiOutContract>(params?: GetVisitsV2Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsV2QueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsV2>>> = ({ signal }) => getVisitsV2(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsV2SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsV2>>>
export type GetVisitsV2SuspenseQueryError = void | ErrorApiOutContract


export function useGetVisitsV2Suspense<TData = Awaited<ReturnType<typeof getVisitsV2>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetVisitsV2Params, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsV2Suspense<TData = Awaited<ReturnType<typeof getVisitsV2>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsV2Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsV2Suspense<TData = Awaited<ReturnType<typeof getVisitsV2>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsV2Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a collection of visits based on the specified filter criteria.
 */

export function useGetVisitsV2Suspense<TData = Awaited<ReturnType<typeof getVisitsV2>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsV2Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsV2SuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetVisitsV2SuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisitsV2>>>, TError = void | ErrorApiOutContract>(params?: GetVisitsV2Params, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsV2InfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsV2>>> = ({ signal }) => getVisitsV2(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsV2SuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsV2>>>
export type GetVisitsV2SuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetVisitsV2SuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsV2>>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetVisitsV2Params, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsV2SuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsV2>>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsV2Params, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsV2SuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsV2>>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsV2Params, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a collection of visits based on the specified filter criteria.
 */

export function useGetVisitsV2SuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsV2>>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsV2Params, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsV2SuspenseInfiniteQueryOptions(params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Retrieves a collection of visits currently in the waiting room.
 */
export const getVisitsWaitingroomV2 = (
    params?: GetVisitsWaitingroomV2Params,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<WaitingRoomV2VisitListItemDoctorApiOutContract[]>(
      {url: `https://providers-api.api.quick.md/api/v2/visits/waitingroom`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetVisitsWaitingroomV2InfiniteQueryKey = (params?: GetVisitsWaitingroomV2Params,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v2/visits/waitingroom`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetVisitsWaitingroomV2QueryKey = (params?: GetVisitsWaitingroomV2Params,) => {
    return [
    `https://providers-api.api.quick.md/api/v2/visits/waitingroom`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetVisitsWaitingroomV2InfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>>, TError = void | ErrorApiOutContract>(params?: GetVisitsWaitingroomV2Params, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsWaitingroomV2InfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>> = ({ signal }) => getVisitsWaitingroomV2(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsWaitingroomV2InfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>>
export type GetVisitsWaitingroomV2InfiniteQueryError = void | ErrorApiOutContract


export function useGetVisitsWaitingroomV2Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetVisitsWaitingroomV2Params, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsWaitingroomV2>>,
          TError,
          Awaited<ReturnType<typeof getVisitsWaitingroomV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsWaitingroomV2Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsWaitingroomV2Params, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsWaitingroomV2>>,
          TError,
          Awaited<ReturnType<typeof getVisitsWaitingroomV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsWaitingroomV2Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsWaitingroomV2Params, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a collection of visits currently in the waiting room.
 */

export function useGetVisitsWaitingroomV2Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsWaitingroomV2Params, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsWaitingroomV2InfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves a collection of visits currently in the waiting room.
 */
export const prefetchGetVisitsWaitingroomV2InfiniteQuery = async <TData = Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, params?: GetVisitsWaitingroomV2Params, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsWaitingroomV2InfiniteQueryOptions(params,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsWaitingroomV2QueryOptions = <TData = Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError = void | ErrorApiOutContract>(params?: GetVisitsWaitingroomV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsWaitingroomV2QueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>> = ({ signal }) => getVisitsWaitingroomV2(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsWaitingroomV2QueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>>
export type GetVisitsWaitingroomV2QueryError = void | ErrorApiOutContract


export function useGetVisitsWaitingroomV2<TData = Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetVisitsWaitingroomV2Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsWaitingroomV2>>,
          TError,
          Awaited<ReturnType<typeof getVisitsWaitingroomV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsWaitingroomV2<TData = Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsWaitingroomV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsWaitingroomV2>>,
          TError,
          Awaited<ReturnType<typeof getVisitsWaitingroomV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsWaitingroomV2<TData = Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsWaitingroomV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a collection of visits currently in the waiting room.
 */

export function useGetVisitsWaitingroomV2<TData = Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsWaitingroomV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsWaitingroomV2QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves a collection of visits currently in the waiting room.
 */
export const prefetchGetVisitsWaitingroomV2Query = async <TData = Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, params?: GetVisitsWaitingroomV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsWaitingroomV2QueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsWaitingroomV2SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError = void | ErrorApiOutContract>(params?: GetVisitsWaitingroomV2Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsWaitingroomV2QueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>> = ({ signal }) => getVisitsWaitingroomV2(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsWaitingroomV2SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>>
export type GetVisitsWaitingroomV2SuspenseQueryError = void | ErrorApiOutContract


export function useGetVisitsWaitingroomV2Suspense<TData = Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetVisitsWaitingroomV2Params, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsWaitingroomV2Suspense<TData = Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsWaitingroomV2Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsWaitingroomV2Suspense<TData = Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsWaitingroomV2Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a collection of visits currently in the waiting room.
 */

export function useGetVisitsWaitingroomV2Suspense<TData = Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsWaitingroomV2Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsWaitingroomV2SuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetVisitsWaitingroomV2SuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>>, TError = void | ErrorApiOutContract>(params?: GetVisitsWaitingroomV2Params, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsWaitingroomV2InfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>> = ({ signal }) => getVisitsWaitingroomV2(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsWaitingroomV2SuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>>
export type GetVisitsWaitingroomV2SuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetVisitsWaitingroomV2SuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetVisitsWaitingroomV2Params, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsWaitingroomV2SuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsWaitingroomV2Params, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsWaitingroomV2SuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsWaitingroomV2Params, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a collection of visits currently in the waiting room.
 */

export function useGetVisitsWaitingroomV2SuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>>, TError = void | ErrorApiOutContract>(
 params?: GetVisitsWaitingroomV2Params, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsWaitingroomV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsWaitingroomV2SuspenseInfiniteQueryOptions(params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Moves a visit back into the waiting room. This is done when a provider moves a visit to "pending".
 */
export const putVisitsVisitIdBackinwaitingroomV2 = (
    visitId: string,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://providers-api.api.quick.md/api/v2/visits/${encodeURIComponent(String(visitId))}/backinwaitingroom`, method: 'PUT'
    },
      options);
    }
  


export const getPutVisitsVisitIdBackinwaitingroomV2MutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdBackinwaitingroomV2>>, TError,{visitId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdBackinwaitingroomV2>>, TError,{visitId: string}, TContext> => {

const mutationKey = ['putVisitsVisitIdBackinwaitingroomV2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putVisitsVisitIdBackinwaitingroomV2>>, {visitId: string}> = (props) => {
          const {visitId} = props ?? {};

          return  putVisitsVisitIdBackinwaitingroomV2(visitId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutVisitsVisitIdBackinwaitingroomV2MutationResult = NonNullable<Awaited<ReturnType<typeof putVisitsVisitIdBackinwaitingroomV2>>>
    
    export type PutVisitsVisitIdBackinwaitingroomV2MutationError = void | ErrorApiOutContract

    /**
 * @summary Moves a visit back into the waiting room. This is done when a provider moves a visit to "pending".
 */
export const usePutVisitsVisitIdBackinwaitingroomV2 = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVisitsVisitIdBackinwaitingroomV2>>, TError,{visitId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putVisitsVisitIdBackinwaitingroomV2>>,
        TError,
        {visitId: string},
        TContext
      > => {

      const mutationOptions = getPutVisitsVisitIdBackinwaitingroomV2MutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * # Possible Errors
            
| HTTP status | ErrorCode | Description |
|--|--|--|
| 400 | ThirdPartyError | Error on third party side. See info in Data object |
| 401 |  |  |
| 403 | Forbidden | See preconditions in description |
| 404 | VisitNotFound | The visit is not found or doesn't belong to the current doctor |
| 500 | InternalServerError | Internal server error |
 * @summary Initiates a video visit call for a visit
 */
export const postVisitsVisitIdVideoV2 = (
    visitId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<VisitVideoDoctorApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v2/visits/${encodeURIComponent(String(visitId))}/video`, method: 'POST', signal
    },
      options);
    }
  


export const getPostVisitsVisitIdVideoV2MutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdVideoV2>>, TError,{visitId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdVideoV2>>, TError,{visitId: string}, TContext> => {

const mutationKey = ['postVisitsVisitIdVideoV2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postVisitsVisitIdVideoV2>>, {visitId: string}> = (props) => {
          const {visitId} = props ?? {};

          return  postVisitsVisitIdVideoV2(visitId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostVisitsVisitIdVideoV2MutationResult = NonNullable<Awaited<ReturnType<typeof postVisitsVisitIdVideoV2>>>
    
    export type PostVisitsVisitIdVideoV2MutationError = void | ErrorApiOutContract

    /**
 * @summary Initiates a video visit call for a visit
 */
export const usePostVisitsVisitIdVideoV2 = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdVideoV2>>, TError,{visitId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postVisitsVisitIdVideoV2>>,
        TError,
        {visitId: string},
        TContext
      > => {

      const mutationOptions = getPostVisitsVisitIdVideoV2MutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * # Possible Errors
| HTTP status | ErrorCode           | Description                                              |
|-------------|---------------------|----------------------------------------------------------|
| 404         | VisitNotFound       | The visit is not found or doesn't belong to the current doctor |
 * @summary Retrieves an access token for participating in a phone call related to a specific visit.
 */
export const getVisitsVisitIdCallTokenV2 = (
    visitId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<PhoneCallAccessTokenDoctorApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v2/visits/${encodeURIComponent(String(visitId))}/call/token`, method: 'GET', signal
    },
      options);
    }
  



export const getGetVisitsVisitIdCallTokenV2InfiniteQueryKey = (visitId?: string,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v2/visits/${visitId}/call/token`
    ] as const;
    }

export const getGetVisitsVisitIdCallTokenV2QueryKey = (visitId?: string,) => {
    return [
    `https://providers-api.api.quick.md/api/v2/visits/${visitId}/call/token`
    ] as const;
    }

    
export const getGetVisitsVisitIdCallTokenV2InfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdCallTokenV2InfiniteQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>> = ({ signal }) => getVisitsVisitIdCallTokenV2(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(visitId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdCallTokenV2InfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>>
export type GetVisitsVisitIdCallTokenV2InfiniteQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdCallTokenV2Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdCallTokenV2Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdCallTokenV2Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves an access token for participating in a phone call related to a specific visit.
 */

export function useGetVisitsVisitIdCallTokenV2Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdCallTokenV2InfiniteQueryOptions(visitId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves an access token for participating in a phone call related to a specific visit.
 */
export const prefetchGetVisitsVisitIdCallTokenV2InfiniteQuery = async <TData = Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsVisitIdCallTokenV2InfiniteQueryOptions(visitId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsVisitIdCallTokenV2QueryOptions = <TData = Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdCallTokenV2QueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>> = ({ signal }) => getVisitsVisitIdCallTokenV2(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(visitId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdCallTokenV2QueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>>
export type GetVisitsVisitIdCallTokenV2QueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdCallTokenV2<TData = Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdCallTokenV2<TData = Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdCallTokenV2<TData = Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves an access token for participating in a phone call related to a specific visit.
 */

export function useGetVisitsVisitIdCallTokenV2<TData = Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdCallTokenV2QueryOptions(visitId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves an access token for participating in a phone call related to a specific visit.
 */
export const prefetchGetVisitsVisitIdCallTokenV2Query = async <TData = Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsVisitIdCallTokenV2QueryOptions(visitId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsVisitIdCallTokenV2SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdCallTokenV2QueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>> = ({ signal }) => getVisitsVisitIdCallTokenV2(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdCallTokenV2SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>>
export type GetVisitsVisitIdCallTokenV2SuspenseQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdCallTokenV2Suspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdCallTokenV2Suspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdCallTokenV2Suspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves an access token for participating in a phone call related to a specific visit.
 */

export function useGetVisitsVisitIdCallTokenV2Suspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdCallTokenV2SuspenseQueryOptions(visitId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetVisitsVisitIdCallTokenV2SuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdCallTokenV2InfiniteQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>> = ({ signal }) => getVisitsVisitIdCallTokenV2(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdCallTokenV2SuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>>
export type GetVisitsVisitIdCallTokenV2SuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdCallTokenV2SuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdCallTokenV2SuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdCallTokenV2SuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves an access token for participating in a phone call related to a specific visit.
 */

export function useGetVisitsVisitIdCallTokenV2SuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdCallTokenV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdCallTokenV2SuspenseInfiniteQueryOptions(visitId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * # Possible Errors
| HTTP status | ErrorCode                  | Description                                                    |
|-------------|----------------------------|----------------------------------------------------------------|
| 404         | VisitNotFound              | The visit is not found or doesn't belong to the current doctor |
 * @summary Enters prepare mode for a visit. For in-person visits, this forces a patient check-in so instructions can be saved.
 */
export const postVisitsVisitIdPrepareV2 = (
    visitId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<void>(
      {url: `https://providers-api.api.quick.md/api/v2/visits/${encodeURIComponent(String(visitId))}/prepare`, method: 'POST', signal
    },
      options);
    }
  


export const getPostVisitsVisitIdPrepareV2MutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdPrepareV2>>, TError,{visitId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdPrepareV2>>, TError,{visitId: string}, TContext> => {

const mutationKey = ['postVisitsVisitIdPrepareV2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postVisitsVisitIdPrepareV2>>, {visitId: string}> = (props) => {
          const {visitId} = props ?? {};

          return  postVisitsVisitIdPrepareV2(visitId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostVisitsVisitIdPrepareV2MutationResult = NonNullable<Awaited<ReturnType<typeof postVisitsVisitIdPrepareV2>>>
    
    export type PostVisitsVisitIdPrepareV2MutationError = void | ErrorApiOutContract

    /**
 * @summary Enters prepare mode for a visit. For in-person visits, this forces a patient check-in so instructions can be saved.
 */
export const usePostVisitsVisitIdPrepareV2 = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdPrepareV2>>, TError,{visitId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postVisitsVisitIdPrepareV2>>,
        TError,
        {visitId: string},
        TContext
      > => {

      const mutationOptions = getPostVisitsVisitIdPrepareV2MutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    